<!-- Created by henian.xu on 2018/7/20. -->

<template>
    <page :back="queryFormModel.businessDistrictId || queryFormModel.storeId">
        <!-- 表单区 -->
        <template slot="secondHeader">
            <el-form
                ref="queryForm"
                class="second-header npa-b"
                size="small"
                :inline="true"
                :model="queryFormModel"
            >
                <el-form-item
                    prop="pageName"
                    label="页面名称"
                >
                    <el-input
                        v-model="queryFormModel.pageName"
                        placeholder="请输入页面名称"
                    />
                </el-form-item>
                <el-form-item>
                    <el-button
                        type="primary"
                        @click="onQuery()"
                    >
                        查询
                    </el-button>
                    <el-button
                        type="success"
                        @click="onReset"
                    >
                        重置
                    </el-button>
                </el-form-item>
            </el-form>
        </template>

        <!-- 内容 -->
        <div
            class="body"
            slot="body"
            v-loading="querying"
        >
            <!-- 操作 -->
            <div
                class="ma-b"
            >
                <el-button-group>
                    <el-button
                        type="success"
                        icon="el-icon-plus"
                        size="small"
                        @click="$router.push(routerName +'?pageType=0' + queryStr)"
                    >
                        新增
                    </el-button>
                </el-button-group>
            </div>

            <!-- 表格 -->
            <el-table
                stripe
                border
                size="small"
                :data="tableData"
                style="width: 100%"
            >
                <el-table-column
                    prop="pageName"
                    label="页面名称"
                    min-width="100"
                />
                <el-table-column
                    label="是否启用"
                    width="80"
                >
                    <template
                        slot-scope="scope"
                        v-if="scope.row.id"
                    >
                        <el-switch
                            v-model="scope.row.isAvailable"
                            @input="onIsAvailableInput($event,scope)"
                        />
                    </template>
                </el-table-column>
                <el-table-column
                    label="是否默认"
                    min-width="100"
                >
                    <template slot-scope="scope">
                        {{ scope.row.isDefault ? '是' : '否' }}
                    </template>
                </el-table-column>
                <el-table-column
                    label="创建时间"
                    width="135"
                >
                    <template slot-scope="scope">
                        {{ scope.row.insertTime | moment('YYYY-MM-DD HH:mm:ss') }}
                    </template>
                </el-table-column>
                <el-table-column
                    label="修改时间"
                    width="135"
                >
                    <template slot-scope="scope">
                        {{ scope.row.updateTime | moment('YYYY-MM-DD HH:mm:ss') }}
                    </template>
                </el-table-column>
                <el-table-column
                    fixed="right"
                    label="操作"
                    width="150"
                >
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            size="small"
                            @click="$router.push(routerName+`/${scope.row.id}?pageType=0` + queryStr)"
                        >
                            编辑
                        </el-button>
                        <template v-if="!scope.row.isDefault">
                            <el-button
                                type="text"
                                size="small"
                                @click="updateIsDefault(scope.row.id)"
                            >
                                设为默认
                            </el-button>
                            <el-button
                                type="text"
                                size="small"
                                @click="onTableDelete(scope.row.id)"
                            >
                                删除
                            </el-button>
                        </template>
                        <el-button
                            type="text"
                            size="small"
                            @click="$router.push( routerName + `?pageType=0&copyId=` + scope.row.id + queryStr)"
                        >
                            复制
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <div class="ma-t ta-r">
                <pagination
                    v-model="pagination"
                    @input="onQuery"
                />
            </div>
        </div>
    </page>
</template>

<script>
import pagesMixin from '@/mixin/layout/pageMixin';
import { queryFormList } from 'vmf/src/mixins';

export default {
    name: 'HomeDecoration',
    mixins: [pagesMixin, queryFormList],
    data() {
        return {
            queryFormModel: {
                pageName: '', // 页面名称
                pageType: '0',
                businessDistrictId: '',
                storeId: '',
            },
            // 表格数据
            tableData: [],
            routerName: '/om/decoration/home/edit',
        };
    },
    methods: {
        /* -- 方法 -- */
        // 请求列表数据
        getListData(queryData) {
            return this.$api.Sp.ShopDecoration.data(queryData).then(json => {
                const res = json.data;
                this.tableData = res.data;
                this.pagination = res.pagination;
                return Promise.resolve(json);
            });
        },
        /* -- 事件 -- */
        onTableDelete(id) {
            this.$confirm('是否确定要删除！', '温馨提示', {
                type: 'warning',
            }).then(() => {
                this.$api.Sp.ShopDecoration.delete({ id }).then(json => {
                    const res = json.data;
                    this.$message({
                        message: res.msg,
                        type: 'success',
                    });
                    this.onQuery(this.pagination);
                });
            });
        },
        updateIsDefault(id) {
            this.$confirm('是否确定要设置为默认！', '温馨提示', {
                type: 'warning',
            }).then(() => {
                this.$api.Sp.ShopDecoration.updateIsDefault({ id }).then(json => {
                    const res = json.data;
                    this.$message({
                        message: res.msg,
                        type: 'success',
                    });
                    this.onQuery(this.pagination);
                });
            });
        },
        onIsAvailableInput(val, scope) {
            const { row } = scope;
            if (!row) return;
            this.$api.Sp.ShopDecoration.status({
                id: row.id,
                isAvailable: row.isAvailable,
            })
                .then(json => {
                    const res = json.data;
                    this.$message({
                        message: res.msg,
                        type: 'success',
                    });
                })
                .catch(() => {
                    this.$message({
                        message: '操作失败请重试！',
                        type: 'error',
                    });
                    row.isAvailable = !row.isAvailable;
                });
        },
    },
    computed: {
        queryStr() {
            if (this.queryFormModel.businessDistrictId)
                return `&businessDistrictId=${this.queryFormModel.businessDistrictId}`;
            if (this.queryFormModel.storeId) return `&storeId=${this.queryFormModel.storeId}`;
            return '';
        },
    },
    created() {
        this.queryFormModel.businessDistrictId = this.$route.params.businessDistrictId || '';
        if (this.queryFormModel.businessDistrictId) {
            this.routerName = '/sp/businessDistrict/home/edit';
        }
        this.queryFormModel.storeId = this.$route.params.storeId || '';
        if (this.queryFormModel.storeId) {
            this.routerName = '/sp/store/home/edit';
        }
    },
};
</script>

<style lang="scss">
</style>
